// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"357":"2446555f","747":"0d0039c2"}[chunkId] + ".chunk.js";
};